const projects = [
  {
    name: 'Pixels Art',
    stacks: 'HTML | JavaScript | CSS',
    github: 'https://github.com/renatapnunes/pixels-art',
  },
  {
    name: 'To-Do List',
    stacks: 'HTML | JavaScript | CSS',
    github: 'https://github.com/renatapnunes/todo-list',
  },
  {
    name: 'Shopping Cart',
    stacks: 'JavaScript | CSS',
    github: 'https://github.com/renatapnunes/shopping-cart',
  },
  {
    name: 'Tests with Jest',
    stacks: 'JavaScript | Jest',
    github: 'https://github.com/renatapnunes/jest',
  },
  {
    name: 'Movie Card Library - CRUD',
    stacks: 'React | CSS',
    github: 'https://github.com/renatapnunes/movie-card-library-crud',
  },
  {
    name: 'Tests with React Testing Library',
    stacks: 'React | RTL',
    github: 'https://github.com/renatapnunes/react-testing-library',
  },
  {
    name: 'MySQL - One For All',
    stacks: 'MySQL',
    github: 'https://github.com/renatapnunes/mysql-one-for-all',
  },
  {
    name: 'MongoDB - Commerce',
    stacks: 'MongoDB',
    github: 'https://github.com/renatapnunes/mongodb-commerce',
  },
  {
    name: 'Cookmaster',
    stacks: 'Node.js | Express.js | JWT | Joi | MongoDB',
    github: 'https://github.com/renatapnunes/cookmaster',
  },
  {
    name: 'Blogs Api',
    stacks: 'Node.js | Express.js | JWT | Joi | Sequelize',
    github: 'https://github.com/renatapnunes/blogs-api',
  },
  {
    name: 'Webchat',
    stacks: 'Node.js | Express.js | Socket.io | MongoDB',
    github: 'https://github.com/renatapnunes/webchat',
  },
  {
    name: 'Delivery App',
    stacks: 'React | Node.js | Express.js | JWT | Joi | Socket.io | Sequelize',
    github: 'https://github.com/renatapnunes/delivery-app',
  },
];

export default projects;
